module.exports = __webpack_public_path__ + "static/media/velo-logo.0bc93a01.svg";